<template>
  <div>
    <DataTable
        class="mt-5 service-ticket-table"
        :loading="currentTabState.isLoading"
        :value="currentTabState.tableData"
        :rows="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :sortField="currentTabState.sortField"
        :sortOrder="currentTabState.sortOrder"
        :rowClass="rowClass"
        selectionMode="single"
        @row-select="onRowSelect"
        @row-click="onRowClick"
        @sort="onSort"
        :lazy="true"
    >
      <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          :sortable="col.sortable"
          :headerStyle="{ width: col.width }"
          :bodyStyle="{ width: col.width }"
          :styles="{ 'text-align': col.align }">
        <template v-if="col.custom" #body="slotProps">
          <slot :name="col.slotName" :rowData="slotProps.data"/>
        </template>
      </Column>
      <template #empty>
        No records found.
      </template>
    </DataTable>
    <Paginator
        :first="currentTabState.first"
        template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        @page="onPageChange"
        :rows="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :rowsPerPageOptions="[10, 20, 50, 100]">
    </Paginator>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {createTabState} from "@/store/modules/service-ticket/serviceTicketStore";

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rowClass: {
      type: Function,
      default: null
    },
    enableRowClick: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapState("serviceTicket", {
      currentTabState: state => state.tabs[state.currentTab] || createTabState(),
    }),
  },
  methods: {
    ...mapActions("serviceTicket", ["updateTableSettings", "updateSortOptions"]),

    onRowSelect(event) {
      this.$emit("row-select", event);
    },
    onRowClick(event) {
      if (this.enableRowClick) {
        this.$emit("row-click", event);
      }
    },
    onPageChange(event) {
      this.updateTableSettings({
        rows: event.rows,
        page: event.page,
      });
    },
    onSort(event) {
      this.updateSortOptions({
        field: event.sortField,
        order: event.sortOrder,
      });
    },
  },
};
</script>

<style scoped>
::v-deep .service-ticket-table .p-datatable-table {
  table-layout: fixed;
}

::v-deep .service-ticket-table .p-datatable-tbody > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
